// Layar kuis: menampilkan soal, memeriksa jawaban, dan membuka panel pembahasan.
import { $, $$ } from '../core/dom.js';
import { fmtClock, fmtDur } from '../core/format.js';
import { pick } from '../core/random.js';
import { S, mapelAktif, panggil } from './state.js';
import { setPemain } from '../subjects/matematika/konteks.js';
import { show } from './screens.js';
import { mascot } from './mascot.js';
import { sfx } from './sound.js';
import { confetti } from './confetti.js';
import { modal, modalTerbuka } from './modal.js';
import { tutor } from './tutor.js';
import { bukaTaka, tutupTaka } from './taka.js';
import { questionHTML, answerHTML, hintFor, selKosong, selLengkap, isRight, keyHTML, userHTML, namaNilai } from './jawaban.js';
import { mulaiRonde, catatJawaban } from '../game/profil.js';
import { tombolLapor, pasangLapor } from './laporan.js';
import { susunRonde, BOBOT_BAWAAN } from '../subjects/matematika/index.js';
import { susunRonde as susunRondeBI, BOBOT_BAWAAN as BOBOT_BI } from '../subjects/bahasa-indonesia/index.js';
import { soalPengembangan } from '../subjects/bahasa-indonesia/pengembangan.js';
import { selesai } from './hasil.js';

// Penyusun ronde per mapel: (n, { bobot, bank, porsiBank }) -> soal[].
const PENYUSUN = {
  matematika: { susun: susunRonde, bobot: BOBOT_BAWAAN },
  'bahasa-indonesia': { susun: (n, o) => susunRondeBI(n, { ...o, pengembangan: soalPengembangan() }), bobot: BOBOT_BI },
};
// Di tablet mendatar soal tetap terlihat di kiri, jadi panel soal di tutorial tidak perlu dibuka.
const tataLetakLebar = () => matchMedia('(min-width:820px) and (min-aspect-ratio:5/4) and (min-height:500px)').matches;
const PUJIAN = [n => `Hebat, ${n}!`, n => `Keren banget, ${n}!`, () => 'Mantap!', n => `${n} jago!`, n => `Luar biasa, ${n}!`, () => 'Pintar sekali!', n => `Wah, tepat, ${n}!`];

/**
 * Mulai ronde kuis. Tanpa opsi: sesuai konfigurasi mapel. Dengan `topik` (dari menu belajar):
 * hanya soal generator topik itu dan soal bank soal bertopik sama.
 * @param {{jumlah?: number, topik?: string[], modul?: string, saran?: boolean}} opsi saran: dimulai dari saran Peta Kemampuan
 */
export function mulaiKuis(opsi = {}) {
  const m = mapelAktif();
  setPemain(S.nama);
  const topik = Array.isArray(opsi.topik) && opsi.topik.length ? opsi.topik : null;
  S.latihanModul = topik ? { topik, jumlah: opsi.jumlah, modul: opsi.modul, saran: !!opsi.saran } : null;
  mulaiRonde();
  const p = PENYUSUN[m.id] || PENYUSUN.matematika;
  const bobot = topik ? Object.fromEntries(Object.keys(p.bobot).map(k => [k, topik.includes(k) ? 1 : 0])) : m.bobotTopik;
  const bank = (S.konten.bank[m.id] || []).filter(q => !topik || topik.some(t => q.topic === 'bank:' + t));
  S.qs = p.susun(opsi.jumlah || S.jumlah, { bobot, bank, porsiBank: m.bankSoal?.porsi || 0 });
  S.i = 0; S.rec = []; S.quizStart = performance.now();
  show('quiz');
  renderQ();
  clearInterval(S.tick);
  S.tick = setInterval(() => {
    if ($('#scr-quiz').hidden) return;
    const now = performance.now();
    $('#t-all').textContent = fmtClock(now - S.quizStart);
    if (!S.answered) $('#t-q').textContent = fmtClock(now - S.tStart);
  }, 250);
}

function renderQ() {
  const q = S.qs[S.i];
  q.sel = selKosong(q); S.answered = false;
  $('#q-num').textContent = `Soal ${S.i + 1}/${S.qs.length}`;
  $('#q-prog').style.width = (S.i / S.qs.length * 100) + '%';
  $('#t-q').textContent = '0:00';
  $('#q-pane').innerHTML = questionHTML(q, { tanya: false });
  $('#q-pane').scrollTop = 0;
  const ap = $('#a-pane');
  const hint = hintFor(q);
  // Soal kelompok: teks bacaan di panel kiri, pertanyaannya di atas pilihan jawaban (seperti TKA).
  const prev = S.qs[S.i - 1], lanjutanTeks = q.bacaan && prev?.bacaan?.id === q.bacaan.id;
  ap.innerHTML = `${q.bacaan ? `<div class="q-tanya-wrap">${lanjutanTeks ? '<span class="pill q-lanjut">Masih teks yang sama</span>' : ''}<div class="qtext q-tanya">${q.text}</div></div>` : ''}<p class="hint">${panggil()}, ${hint[0].toLowerCase() + hint.slice(1)}</p><div class="ans scroll">${answerHTML(q)}</div><div class="actions" id="a-actions"><button class="btn btn-sun" id="btn-check" type="button" disabled>Periksa jawaban</button></div>`;
  const sh = $('#sheet'); sh.hidden = true; sh.innerHTML = ''; sh.className = 'sheet';
  tutupTaka();
  $$('.opt', ap).forEach(b => b.onclick = () => pilih(+b.dataset.i));
  $$('.bs-b', ap).forEach(b => b.onclick = () => {
    if (S.answered) return;
    const r = +b.dataset.r;
    q.sel[r] = b.dataset.v === '1';
    $$(`.bs-b[data-r="${r}"]`, ap).forEach(x => x.classList.toggle('on', x === b));
    sfx.tap(); perbaruiTombol();
  });
  $('#btn-check').onclick = periksa;
  // HP: soal berikutnya untuk teks yang sama langsung menuju pertanyaannya (teks tetap di atas).
  if (lanjutanTeks && !tataLetakLebar()) requestAnimationFrame(() => ap.scrollIntoView({ block: 'start' }));
  S.tStart = performance.now();
}

function pilih(i) {
  const q = S.qs[S.i], ap = $('#a-pane');
  if (S.answered) return;
  if (q.type === 'pg') { q.sel = i; $$('.opt', ap).forEach((b, j) => b.classList.toggle('sel', j === i)); }
  else {
    q.sel.has(i) ? q.sel.delete(i) : q.sel.add(i);
    $$('.opt', ap).forEach((b, j) => { b.classList.toggle('sel', q.sel.has(j)); b.setAttribute('aria-pressed', q.sel.has(j)); });
  }
  sfx.tap(); perbaruiTombol();
}
const perbaruiTombol = () => { const q = S.qs[S.i]; $('#btn-check').disabled = !selLengkap(q, q.sel); };

function periksa() {
  const q = S.qs[S.i];
  if (S.answered) return;
  S.answered = true;
  const ms = performance.now() - S.tStart, ok = isRight(q, q.sel), ap = $('#a-pane');
  $$('.opt,.bs-b', ap).forEach(b => b.disabled = true);
  if (q.type === 'pg') $$('.opt', ap).forEach((b, i) => {
    if (i === q.answer) { b.classList.add('ok'); b.querySelector('.tag').textContent = 'Jawaban benar'; }
    else if (i === q.sel) { b.classList.add('no'); b.querySelector('.tag').textContent = 'Pilihanmu'; }
  });
  if (q.type === 'mcma') $$('.opt', ap).forEach((b, i) => {
    const s = q.sel.has(i), v = q.options[i].v, tag = b.querySelector('.tag');
    if (v && s) { b.classList.add('ok'); tag.textContent = 'Benar ✓'; }
    else if (v) { b.classList.add('miss'); tag.textContent = 'Harusnya dipilih'; }
    else if (s) { b.classList.add('no'); tag.textContent = 'Bukan jawaban'; }
  });
  if (q.type === 'bs') $$('.bs-row', ap).forEach((row, i) => {
    const good = q.sel[i] === q.statements[i].v;
    row.classList.add(good ? 'ok' : 'no');
    row.insertAdjacentHTML('beforeend', `<div class="bs-key">${good ? 'Tepat' : 'Belum tepat'}, jawabannya ${namaNilai(q, q.statements[i].v).toUpperCase()}.</div>`);
  });
  S.rec.push({ n: S.i + 1, el: q.el, title: q.title, ok, ms, q, sel: q.type === 'mcma' ? new Set(q.sel) : Array.isArray(q.sel) ? [...q.sel] : q.sel });
  catatJawaban(q, ok);
  // Soal kelompok: sorot bukti jawabannya di teks bacaan.
  if (q.bacaan && q.bukti?.length) {
    const qp = $('#q-pane'), top = qp.scrollTop;
    qp.innerHTML = questionHTML(q, { tanya: false, sorot: q.bukti });
    qp.scrollTop = top;
    if (tataLetakLebar()) qp.querySelector('mark')?.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }
  const bahas = !!q.bacaan, lihat = bahas ? 'Lihat pembahasan' : 'Lihat cara menghitung';

  const last = S.i === S.qs.length - 1, lanjut = last ? 'Lihat hasil →' : 'Soal berikutnya →';
  $('#a-actions').innerHTML = `<button class="btn btn-sm" id="btn-reopen" type="button">${ok ? lihat : 'Buka pembahasan'}</button><button class="btn btn-go" id="btn-next2" type="button">${lanjut}</button>`;
  $('#btn-next2').onclick = berikutnya;

  const sh = $('#sheet');
  sh.className = 'sheet ' + (ok ? 'good' : 'bad');
  const n = panggil();
  sh.innerHTML = `<div class="sheet-head">${mascot(ok ? 'cheer' : 'sad', 72, 'bounce')}<div class="grow"><h3>${ok ? pick(PUJIAN)(n) : `Belum tepat, ${n}. Tidak apa-apa!`}</h3><p>${ok ? `${n} menjawab dalam ${fmtDur(ms)}.` : (bahas ? 'Yuk, kita cari buktinya di teks dan lihat kenapa jawabanmu belum tepat.' : 'Yuk, kita pelajari caranya bareng. Ikuti langkahnya satu per satu.')}</p></div><button class="toggle" id="btn-hide" type="button">${ok ? 'Tutup' : 'Lihat jawabanku'}</button></div>
    <div class="sheet-body">${ok ? '' : `<details class="keybox"${tataLetakLebar() && innerHeight >= 900 ? ' open' : ''}><summary>Jawabanmu dan jawaban yang benar</summary><span class="you">Jawabanmu: ${userHTML(q, q.sel)}</span>Jawaban yang benar: ${keyHTML(q)}</details>`}<div class="tutor-host grow"></div></div>
    <div class="sheet-foot">${ok ? `<button class="btn btn-sm" id="btn-how" type="button">${lihat}</button>` : `<button class="taka-launch" id="btn-taka" type="button">${mascot('wow', 46)}<span>Masih bingung?<b>Tanya TAKA</b></span></button>`}${tombolLapor()}<button class="btn btn-go" id="btn-next" type="button">${lanjut}</button></div>`;
  sh.hidden = false;
  pasangLapor(sh, q, q.sel);
  const host = sh.querySelector('.tutor-host');
  let tut = null;
  const bukaTutor = () => { sh.classList.add('full'); $('#btn-how')?.remove(); if (!host.dataset.on) { host.dataset.on = 1; tut = tutor(q, host, { tampilSoal: !tataLetakLebar() && !q.bacaan, sel: q.sel }); } };
  $('#btn-taka')?.addEventListener('click', () => bukaTaka({ q, sel: q.sel, langkahAktif: () => tut?.langkahAktif() ?? null }));
  $('#btn-hide').onclick = () => { sh.hidden = true; };
  $('#btn-reopen').onclick = () => { sh.hidden = false; if (ok) bukaTutor(); };
  $('#btn-next').onclick = berikutnya;
  if (ok) { sfx.ok(); confetti(40); $('#btn-how').onclick = bukaTutor; }
  else { sfx.no(); bukaTutor(); }
}

function berikutnya() {
  if (S.i < S.qs.length - 1) { S.i++; renderQ(); }
  else akhiri();
}
function akhiri() { clearInterval(S.tick); selesai(performance.now() - S.quizStart); }

export function initKuis() {
  document.addEventListener('keydown', e => {
    if (modalTerbuka() || $('#scr-quiz').hidden || e.target.tagName === 'INPUT') return;
    const q = S.qs[S.i];
    if (!S.answered && q && q.type !== 'bs' && e.key.length === 1) {
      const k = e.key.toUpperCase(), idx = '123456'.includes(k) ? '123456'.indexOf(k) : 'ABCDEF'.indexOf(k);
      if (idx >= 0 && idx < q.options.length) { pilih(idx); e.preventDefault(); return; }
    }
    if (e.key === 'Enter' && !e.target.closest('button')) {
      if (!S.answered && !$('#btn-check').disabled) { periksa(); e.preventDefault(); }
      else if (S.answered) { berikutnya(); e.preventDefault(); }
    }
  });
  $('#btn-sound').onclick = () => { S.sound = !S.sound; const b = $('#btn-sound'); b.setAttribute('aria-pressed', S.sound); b.querySelector('.lbl').textContent = 'Suara: ' + (S.sound ? 'nyala' : 'mati'); };
  $('#btn-quit').onclick = () => modal(`${mascot('sad', 80).replace('class="mascot ', 'style="margin:0 auto" class="mascot ')}<h3>${panggil()}, yakin mau berhenti?</h3><p>Soal yang belum dikerjakan akan dihitung salah.</p>`,
    [{ label: 'Lanjut mengerjakan', cls: 'btn-go' }, { label: 'Ya, akhiri', cls: 'btn-pink', on: akhiri }]);
}
